export default __webpack_public_path__ + "static/media/paiGowTableWindows.30a2e5ae.webp";